<template>
	<form action="#" method="post" @submit.prevent="submit">
		<!-- Form Fields -->
		<h2>How Much Would You Like To Invest?</h2>

		<h4 class="mt-md-5 pt-4 mb-4">Your Contribution</h4>
		<div class="spinner-border text-black-50 opacity-25 mb-3 d-block" v-if="!offer.loaded"></div>
		<div class="form-field mb-3" v-if="offer.loaded">
			<label for="amount" class="form-label">Enter Amount</label>
			<CurrencyInput placeholder="Enter amount in USD" v-model="initialAmount"/>
<!--			<p class="small mt-2">Minimum investment: ${{ offer.minimum }}</p>-->
			<p class="small fw-bolder text-danger mt-2" v-if="amountError">{{ amountError }}</p>
		</div>
		<div class="form-check check-checkbox mt-3 mb-3">
			<input class="form-check-input" type="checkbox" name="authorization" value="authorization" id="authorization" v-model="authorization">
			<label class="form-check-label" for="authorization">
				<span>By checking this box you authorize this transaction and agree to our <a :href="termsAndConditionsLink" target="_blank">Terms of Use</a>, <a :href="eftDisclosureLink" target="_blank">EFT Disclosure</a> & <a href="https://reiturn.com/investment-disclosure" target="_blank">Investment Disclosure</a>.</span>
			</label>
			<p class="small fw-bolder text-danger mt-2" v-if="authorizationError">Please confirm that you authorize this transaction.</p>
		</div>

		<!-- Auto-investment temporary disabled -->
		<div class="d-none">
			<div class="icon-box mt-4 mt-md-5">
				<img src="./../../assets/icons/refresh.svg" alt="Auto-investment Icon">
			</div>
			<h4 class="mt-4">Set up Auto-investment <span class="text-muted">(Optional)</span></h4>
			<p class="w-75">Auto-invest enables you to schedule automatic contributions to your account.</p>
			<div class="form-field mt-3 pt-3">
				<label class="form-label">Frequency</label>
				<div class="d-flex flex-wrap mt-1">
					<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
						<input type="radio" class="form-check-input" id="autoInvestmentFrequencyDisabled" name="autoInvestmentFrequency" value="Disabled" v-model="autoInvestment.frequency">
						<label for="autoInvestmentFrequencyDisabled" class="form-check-label px-5">Only Once</label>
					</div>
					<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
						<input type="radio" class="form-check-input" id="autoInvestmentFrequencyMonthly" name="autoInvestmentFrequency" value="Monthly" v-model="autoInvestment.frequency">
						<label for="autoInvestmentFrequencyMonthly" class="form-check-label px-5">Once a month</label>
					</div>
					<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
						<input type="radio" class="form-check-input" id="autoInvestmentFrequencyTwoWeeks" name="autoInvestmentFrequency" value="Two Weeks" v-model="autoInvestment.frequency">
						<label for="autoInvestmentFrequencyTwoWeeks" class="form-check-label px-5">Twice a month</label>
					</div>
					<div class="form-check button-checkbox rounded-checkbox mt-2">
						<input type="radio" class="form-check-input" id="autoInvestmentFrequencyWeekly" name="autoInvestmentFrequency" value="Weekly" v-model="autoInvestment.frequency">
						<label for="autoInvestmentFrequencyWeekly" class="form-check-label px-5">Weekly</label>
					</div>
				</div>
			</div>
		</div>

		<div class="form-field mt-3 pt-3" v-if="autoInvestment.frequency !== 'Disabled'">
			<label for="startDay" class="form-label">Day Of Month</label>
			<select class="form-control" name="startDay" id="startDay" required v-model="autoInvestment.startDay">
				<option>1</option>
				<option>2</option>
				<option>3</option>
				<option>4</option>
				<option>5</option>
				<option>6</option>
				<option>7</option>
				<option>8</option>
				<option>9</option>
				<option>10</option>
				<option>11</option>
				<option>12</option>
				<option>13</option>
				<option>14</option>
				<option>15</option>
				<option>16</option>
				<option>17</option>
				<option>18</option>
				<option>19</option>
				<option>20</option>
				<option>21</option>
				<option>22</option>
				<option>23</option>
				<option>24</option>
				<option>25</option>
				<option>26</option>
				<option>27</option>
				<option>28</option>
				<option>29</option>
				<option>30</option>
				<option>31</option>
			</select>
		</div>
		<div class="form-field mt-3 pt-3" v-if="autoInvestment.frequency !== 'Disabled'">
			<label class="form-label">Amount</label>
			<div class="d-flex flex-wrap">
				<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
					<input type="radio" class="form-check-input" id="autoInvestmentAmount100" name="autoInvestmentAmount" value="100" v-model="autoInvestment.amount">
					<label for="autoInvestmentAmount100" class="form-check-label px-5">$100</label>
				</div>
				<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
					<input type="radio" class="form-check-input" id="autoInvestmentAmount250" name="autoInvestmentAmount" value="250" v-model="autoInvestment.amount">
					<label for="autoInvestmentAmount250" class="form-check-label px-5">$250</label>
				</div>
				<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
					<input type="radio" class="form-check-input" id="autoInvestmentAmount500" name="autoInvestmentAmount" value="500" v-model="autoInvestment.amount">
					<label for="autoInvestmentAmount500" class="form-check-label px-5">$500</label>
				</div>
				<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
					<input type="radio" class="form-check-input" id="autoInvestmentAmount1000" name="autoInvestmentAmount" value="1000" v-model="autoInvestment.amount">
					<label for="autoInvestmentAmount1000" class="form-check-label px-5">$1000</label>
				</div>
				<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
					<input type="radio" class="form-check-input" id="autoInvestmentAmount1500" name="autoInvestmentAmount" value="1500" v-model="autoInvestment.amount">
					<label for="autoInvestmentAmount1500" class="form-check-label px-5">$1500</label>
				</div>
				<div class="form-check button-checkbox rounded-checkbox mt-2 me-2">
					<input type="radio" class="form-check-input" id="autoInvestmentAmountOther" name="autoInvestmentAmount" value="Other" v-model="autoInvestment.amount">
					<label for="autoInvestmentAmountOther" class="form-check-label px-5">Other</label>
				</div>
			</div>
		</div>
		<div class="form-field mt-3 pt-3" id="otherAmountField" v-if="autoInvestment.frequency !== 'Disabled' && autoInvestment.amount === 'Other'">
			<label for="otherAmount" class="form-label">Other Amount</label>
			<input type="number" class="form-control" name="otherAmount" id="otherAmount" placeholder="Enter amount" v-model="autoInvestment.otherAmount">
		</div>

		<!-- Form Navigation -->
		<div class="d-flex flex-column-reverse flex-md-row justify-content-md-end pt-5">
<!--			<button class="btn btn-outline-dark me-md-2 mt-2 mt-md-0" type="button" @click.prevent="back">Back</button>-->
			<button class="btn btn-primary btn-wide" type="submit" :disabled="loading">
				<span v-if="!loading">Continue</span>
				<span class="spinner-border" v-if="loading"></span>
			</button>
		</div>
	</form>
</template>

<script>
import repository from "@/repository/repository";
import {PORTAL_URL} from "@/main";
import Logs from "@/repository/logs";
import CurrencyInput from "@/components/widgets/CurrencyInput";

export default {
    name: "InvestmentForm",
    components: {CurrencyInput, },
    beforeMount() {
        // Verify the previous step is completed
        if(!this.$store.getters.contact.completed) {
            this.$router.replace("/details/contact-tax-reporting");
        }

        // Verify if KYC is required, and if it is completed
		if(this.$store.getters.kyc.required && !this.$store.getters.kyc.completed) {
            this.$router.replace("/details/kyc");
		}

        // Verify if the current step is finished
        if(this.$store.getters.investment.finished) {
            this.$router.replace("/details/bank-account");
        }
    },
	created() {
        repository.get("/offer")
			.then(response => {
                this.offer.minimum = response.data.offer.minimumInvestment;
                this.offer.maximum = response.data.offer.maximumInvestment;
                this.offer.unitPrice = response.data.offer.unitPrice;
                this.offer.loaded = true;
			})
    },
    data() {
        return {
            initialAmount: this.$store.getters.investment.initialAmount,
            autoInvestment: {
                frequency: this.$store.getters.investment.autoInvestment.frequency,
                startDay: this.$store.getters.investment.autoInvestment.startDay,
                amount: this.$store.getters.investment.autoInvestment.amount,
                otherAmount: this.$store.getters.investment.autoInvestment.otherAmount,
			},
			offer: {
				minimum: null,
				maximum: null,
				unitPrice: null,
				loaded: false,
			},
            showErrors: false,
            amountError: false,
            authorization: false,
            authorizationError: false,
			loading: false,
        }
    },
    methods: {
        back() {
            this.$store.commit("updateInvestment", {
                initialAmount: this.initialAmount,
                autoInvestment: {
                    frequency: this.autoInvestment.frequency,
                    startDay: this.autoInvestment.startDay,
                    amount: this.autoInvestment.amount,
                    otherAmount: this.autoInvestment.otherAmount,
				},
            });
            this.$router.back();
        },
        submit() {
            if(!this.verifyAmount()) return;
            if(!this.verifyAuthorisation()) return;

            this.loading = true;

            this.$store.commit("updateInvestment", {
                initialAmount: this.initialAmount,
                autoInvestment: {
                    frequency: this.autoInvestment.frequency,
                    startDay: this.autoInvestment.startDay,
                    amount: this.autoInvestment.amount,
                    otherAmount: this.autoInvestment.otherAmount,
                },
            });

            let payload = {
                emailAddress: this.$store.getters.auth.email,
                accountId: this.$store.getters.northCapital.accountId,
                initialAmount: this.$store.getters.investment.initialAmount,
                frequency: this.$store.getters.investment.autoInvestment.frequency,
                startDay: this.$store.getters.investment.autoInvestment.startDay,
                amount: (this.$store.getters.investment.autoInvestment.amount === 'Other' ? this.$store.getters.investment.autoInvestment.otherAmount : this.$store.getters.investment.autoInvestment.amount),
            };
            repository.post("/investments", payload)
                .then(response => {
                    console.log(response);
                    this.loading = false;
                    this.$store.commit("finishInvestments");
                    this.$router.push("/details/bank-account");
                    this.$gtag.event('onboarding_completed_investment_plan', {amount: this.initialAmount});
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'onboarding_completed_investment_plan',
                        'amount': this.initialAmount,
                    });
                })
                .catch(error => {
                    console.log(error);
                    Logs.save('onboarding.investmentForm', error.response, payload);
                })

        },
		verifyAmount() {
            console.log(this.initialAmount);
            this.amountError = false;
            if(this.initialAmount < this.offer.minimum) {
                this.amountError = "Your investment amount should be at least $" + this.offer.minimum.toLocaleString();
                return false;
			}
            if(this.initialAmount > this.offer.maximum) {
                this.amountError = "Your investment amount cannot be more than $" + this.offer.maximum.toLocaleString();
                return false;
			}
            if(this.initialAmount % this.offer.unitPrice !== 0) {
                this.initialAmount = (Math.floor(this.initialAmount / this.offer.unitPrice) * this.offer.unitPrice);
			}
            return true;
		},
        verifyAuthorisation() {
            if(!this.authorization) {
                this.authorizationError = true;
                return false;
            }
            this.authorizationError = false;
            return true;
        },
    },
    computed: {
        termsAndConditionsLink() {
            return PORTAL_URL + "/legal/tos";
        },
        eftDisclosureLink() {
            return PORTAL_URL + "/legal/eft-disclosure";
        },
    },
}
</script>

<style lang="scss">
.icon-box {
	padding: 1.75rem 2rem;
	border-radius: 0.35rem;
	background: #f1f6f8;
	display: inline-block;

	img {
		width: 1.25rem;
	}
}
</style>